import { EventJournalQueries } from '@entities/eventJournal/model/queries';

export const PERIOD_PICKER_QUERY = EventJournalQueries.period;
export const PERIOD_SEPARATOR = ' - ';
